var exports = {
  "Qs": "content__XDjc0-",
  "_0": "detail__uWNIaG",
  "h_": "description__my4gUM",
  "Mx": "sourcesSection__FPH8l4",
  "bV": "sectionHeader__Dm8kW3",
  "f5": "sectionContent__ugIQ6e",
  "kp": "visibilitySection__0eFaJ5",
  "ij": "descriptionText__NuTT6z",
  "Qw": "titleText__JhdX_n",
};

module.exports = exports;
